import { Button, dialog } from "nq-component";
import BaseFormPage from "../../../base/BaseFormPage";
import CardView from "../../../components/common/CardView";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import RichText from "../../../components/common/RichText";
import attach from "../../../components/common/attachment.jpg";
import { findObjectUseCase, upsertUseCase } from "../../../usecases/object";
import { SubmitImg } from "../../../components/common/Converter";
import { createNotification } from "../../../createNotification";

export default class ServiceRequestForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      requestType: "",
      description: "",
      request_Type: [],
      selectedFiles: [],
      instruction: "",
      workFlow: {},
    };
  }

  fields = ["region", "office", "division", "section", "unit", "cluster"];

  getLastNonEmptyField(source) {
    let result;
    let index;
    this.fields.forEach((field, i) => {
      if (
        (source[field] && source[field] !== "") ||
        (source[field] && source[field] !== undefined)
      ) {
        result = source[field];
        index = i;
      }
    });

    return { result, index };
  }

  async componentDidMount() {
    const getCurrentUser = this.getCurrentUser();
    // const getUser = getCurrentUser.id;

    const employees = await findObjectUseCase().execute("employees", {
      where: { id: getCurrentUser.employee.id },
      keys: this.fields,
    });

    const query = {
      where: {},
      include: ["requestType"], // Include requestType
      sort: { name: 1 },
      // limit: 1,
    };

    // Execute the query to find matching workflows
    const request_Type = await findObjectUseCase().execute("work_flows", query);
    console.log("request_Type: ", request_Type);
    const filtered = request_Type.filter((item) => {
      const org = this.getLastNonEmptyField(item?.tasks?.[0]?.hierarchy);

      // console.log("ORG: ", org);
      const emp = employees?.[0];
      if (!emp) return false;

      if (item?.tasks?.[0]?.selectAllEmployee) {
        return true;
      }

      if (
        !item?.tasks?.[0]?.isAssignToRequestor &&
        item?.tasks?.[0]?.hierarchy?.assignedPersonnel &&
        item?.tasks?.[0]?.hierarchy?.assignedPersonnel?.id !==
          getCurrentUser.employee.id
      )
        return false;

      const field = this.fields?.[org.index];
      if (!field) return true;

      // strict equality comparison
      const isEqual = emp[field] === org.result;

      return isEqual;
    });

    console.log("selectAllEmployee: ", request_Type);

    // console.log("req: ", filtered);

    // Set the state with the matched workflows
    this.setState({ request_Type: filtered });
    // console.log("USER: ", getUser);
  }

  handleRequestType(requestType) {
    console.log("REQUEST:: ", requestType);
    this.setState({
      requestType,
      instruction: requestType?.instruction || "",
      workFlow: requestType.id,
    });
  }

  handleDescriptionChange(description) {
    this.setState({ description });
  }

  handleDragOver(event) {
    event.preventDefault();
    this.setState({ dragging: true });
  }

  handleDragLeave() {
    this.setState({ dragging: false });
  }

  handleDrop(event) {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...files],
      dragging: false,
    }));
  }

  handleFileChange(event) {
    const files = Array.from(event.target.files);
    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...files],
    }));
  }

  handleRemoveFile(index) {
    this.setState((prevState) => {
      const selectedFile = prevState.selectedFiles.filter(
        (_, i) => i !== index,
      );
      return { selectedFiles: selectedFile };
    });
  }

  async confirmBtn() {
    const { requestType, description, selectedFiles, workFlow } = this.state;
    const currentUser = this.getCurrentUser();
    let arrayFile;
    if (selectedFiles.length > 0) {
      arrayFile = await SubmitImg(selectedFiles);
    } else {
      arrayFile = [];
    }
    const taskIndex = workFlow?.tasks.length;
    const employees = await findObjectUseCase().execute("employees", {
      where: { id: currentUser?.employee?.id },
      keys: ["supervisor"],
    });

    // console.log("EMPL: ", employees);

    const data = {
      requestType: requestType.value,
      description,
      employee: { id: currentUser?.employee?.id },
      selectedFiles: arrayFile,
      taskIndex,
      stats: "Pending",
      workFlow,
    };

    if (employees[0]?.supervisor) {
      data.supervisor = { id: employees[0]?.supervisor?.id };
    }
    // console.log("DATAAA: ", data);
    // return;

    await upsertUseCase().execute("requests", data);
    data.workFlow.tasks.map(async (item) => {
      const logs = {
        user: { id: item.hierarchy.retrive.id },
        employee: { id: this.getCurrentUser().employee.id },
        activity: `ADD ${requestType.value}`,
        workFlow: requestType.id.name,
        message: "Successfully Added service request!",
        selectedFiles: data.selectedFiles,
      };
      await upsertUseCase().execute("service_request_logs", logs);
    });
    dialog.close();
    this.showSuccess("You have successfully submitted your request!");

    //  CREATE NOTIFICATION
    const notifications = [
      {
        message: "You have been assigned as an approver on your Task Board!",
        receiver: [data.workFlow.tasks[0].hierarchy.approve.id],
      },
      {
        message: "You have been assigned as a rejector on your Task Board!",
        receiver: [data.workFlow.tasks[0].hierarchy.reject.id],
      },
    ];

    notifications.forEach(({ message, receiver }) => {
      createNotification(message, receiver, "taskboard");
    });

    this.props.refetchData();
    this.setState({
      requestType: "",
      description: "",
      instruction: "",
      selectedFiles: [],
      isLoading: false,
    });
  }

  handleSubmit() {
    dialog.fire({
      html: (
        <>
          <div className="p-2">
            <h4>Confirmation</h4>
            <hr />
            <p className="pt-3 pb-3">Click confirm to proceed.</p>
            <hr />
            <div className="d-flex justify-content-end gap-4 mb-3">
              <button className="btn btn-light" onClick={() => dialog.close()}>
                Cancel
              </button>
              <Button
                onClick={() => {
                  this.setState({ isLoading: true });
                  this.confirmBtn();
                }}
                className="btn btn-primary"
                progress={this.state.isLoading}
              >
                Confirm
              </Button>
            </div>
          </div>
        </>
      ),
      footer: false,
    });
  }

  render() {
    const { dragging, selectedFiles } = this.state;

    const dragAndDropStyle = {
      border: dragging ? "2px dashed #000" : "2px dashed #ccc",
      padding: "1rem",
      borderRadius: "4px",
      textAlign: "center",
      margin: "1rem 0",
      position: "relative",
      cursor: "pointer",
    };
    // console.log("request_Type: ", this.state.request_Type);
    return (
      <>
        <CardView>
          <form
            className="mt-2"
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSubmit();
            }}
          >
            <h4 className="text-primary">Service Request Form</h4>
            <hr />

            <div className="row p-3">
              {/* form  */}
              <div className="col-lg-8 border" style={{ padding: "1rem 0" }}>
                <p className="fw-bold ps-4">Request Details</p>
                <hr />

                <div style={{ padding: "1rem 1.5rem" }}>
                  <label className="mb-2">
                    Request Type <span className="text-danger">*</span>
                  </label>
                  <SearchSelect
                    value={this.state.requestType.value}
                    focus={true}
                    onChange={this.handleRequestType.bind(this)}
                    onClickClear={() => this.handleRequestType("")}
                    required={true}
                    options={this.state.request_Type.map((type) => ({
                      label: type.name,
                      value: {
                        value: type.name,
                        id: type,
                        instruction: type.requestType.Instructions,
                      },
                    }))}
                  />
                  <div style={{ margin: "2rem 0" }}>
                    <RichText
                      onContentChange={this.handleDescriptionChange.bind(this)}
                      content={this.state.description}
                    />
                  </div>

                  <div className="mt-4">
                    <div
                      style={dragAndDropStyle}
                      onDragOver={this.handleDragOver.bind(this)}
                      onDragLeave={this.handleDragLeave.bind(this)}
                      onDrop={this.handleDrop.bind(this)}
                    >
                      <div className="row" style={{ fontSize: "15px" }}>
                        <img
                          style={{
                            margin: "auto",
                            height: "5rem",
                            width: "5rem",
                            padding: 0,
                          }}
                          src={attach}
                          alt="attachment"
                        />
                        <span className="m-0 p-0">
                          Drag and drop files here or click to upload
                        </span>
                      </div>
                      <input
                        type="file"
                        multiple
                        className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                        style={{
                          cursor: "pointer",
                        }}
                        onChange={this.handleFileChange.bind(this)}
                      />
                    </div>
                    <div>
                      {selectedFiles.map((file, index) => (
                        <div
                          key={index}
                          className="text-danger d-flex justify-content-center align-items-center mb-2"
                        >
                          {this.state.objectID !== "" ? (
                            typeof file === "string" ? (
                              <a href={file} target="_blank" rel="noreferrer">
                                {file.name || file}
                              </a>
                            ) : (
                              file.name || file
                            )
                          ) : (
                            file.name || file
                          )}{" "}
                          <i
                            className="bi bi-trash ms-auto"
                            onClick={() => this.handleRemoveFile(index)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <p style={{ color: "rgba(0, 0, 0, .50)" }}>
                  Note: All Service Request will automatically be forwarded to
                  the concern department for processing. Please make sure that
                  all details are correct and complete. Upload all supporting
                  documents if applicable.
                </p>
                <p style={{ color: "rgba(0, 0, 0, .65)" }}>Instructions:</p>
                <hr />
                <p
                  dangerouslySetInnerHTML={{ __html: this.state.instruction }}
                />
              </div>
            </div>
            <hr />
            <div className="d-flex justify-content-end">
              <button
                // onClick={this.handleSubmit.bind(this)}
                type="submit"
                className="btn btn-primary w-auto"
              >
                Submit
              </button>
            </div>
          </form>
        </CardView>
      </>
    );
  }
}
